<div class="app-view-container dashboard">
  <div class="app-content-container">
    <div class="content-grid">
      <div class="h-auto widget public-collections-container">
        <thehubz-collection-dashboard-view></thehubz-collection-dashboard-view>
      </div>
      <div class="h-auto widget public-assets-container">
        <thehubz-asset-dashboard-keywords></thehubz-asset-dashboard-keywords>
      </div>
    </div>
  </div>
</div>
